import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Admin from '../layout/Admin.vue'
import Auth from '../layout/Auth.vue'
import * as firebase from "firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Admin,
    children: [
        {
          path: '/',
          name:'Home',
          component: Home,
          meta: {
            auth: true
          }
        },
      {
        path: 'usuarios',
        name:'Users',
        component: () => import('../views/User.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: 'categorias',
        name:'Category',
        component: () => import('../views/category/ActivityCategory.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: 'subcategorias',
        name:'SubCategory',
        component: () => import('../views/category/ActivitySubCategory.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: 'clases',
        name:'Activity',
        component: () => import('../views/Activity.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/clases/actividades/:id',
        name:'ActivityClase',
        component: () => import('../views/CreatedClase.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/myclass',
        name:'MyClass',
        component: () => import('../views/ClasesUsuarios.vue'),
        meta: {
          auth: true
        }
      },

      {
        path: '/hitorial',
        name:'History',
        component: () => import('../views/History.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/niveles',
        name:'Level',
        component: () => import('../views/Level.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/practicas',
        name:'Practices',
        component: () => import('../views/Practice.vue'),
        meta: {
          auth: true
        }
      },

      {
        path: '/pictionary-admin',
        name:'PictionaryAdmin',
        component: () => import('../views/PictionaryAdmin.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/pictionary',
        name:'Pictionary',
        component: () => import('../views/Pictionary.vue'),
        meta: {
          auth: true
        }
      },

      {
        path: '/myclass/:index/:id',
        name:'PerformActivity',
        component: () => import('../views/PerformActivity.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/video',
        name:'VideoMenu',
        component: () => import('../views/practicas/VideoMenuAdmin.vue'),
        meta: {
          auth: true
        }
      },


      {
        path: '/video/category',
        name:'VideoCategory',
        component: () => import('../views/practicas/VideoCategory.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/video/management',
        name:'VideoManagement',
        component: () => import('../views/practicas/VideoAdminPractica.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/video-practica',
        name:'VideoPractica',
        component: () => import('../views/practicas/VideoPractica.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/video-practica/:categoryId',
        name:'VideoPracticaCategory',
        component: () => import('../views/practicas/VideoPracticaCategory.vue'),
        meta: {
          auth: true
        }
      },

        //musical
      {
        path: '/musical/category',
        name:'MusicalCategory',
        component: () => import('../views/practicas/musical/MusicalCategory.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/musical/management',
        name:'MusicalManagement',
        component: () => import('../views/practicas/musical/MusicalAdmin.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/musical-practica',
        name:'MusicalPractica',
        component: () => import('../views/practicas/musical/MusicalPractica.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/musical-practica/:categoryId',
        name:'MusicalPracticaCategory',
        component: () => import('../views/practicas/musical/MusicalPracticaCategory.vue'),
        meta: {
          auth: true
        }
      },


      {
        path: '/juegos/sopa-letras',
        name:'SoupLetter',
        component: () => import('../views/letras/SoupLetter.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/admin-category/sopa-letras',
        name:'SoupLetterCategory',
        component: () => import('../views/letras/SoupLetterCategory.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/admin-juego/sopa-letras',
        name:'SoupLetterAdmin',
        component: () => import('../views/letras/SoupLetterAdmin.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/admin-menu/sopa-letras',
        name:'SoupLetterAdminMenu',
        component: () => import('../views/letras/SoupLetterAdminMenu.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/admin-juegos',
        name:'GameAdminMenu',
        component: () => import('../views/GameAdminMenu.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/juegos/crucigrama',
        name:'Crucigrama',
        component: () => import('../views/crucigrama/Crucigrama.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/admin-juego/crucigrama/:id',
        name:'CrucigramaAdmin',
        component: () => import('../views/crucigrama/CrucigramaAdmin.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/admin-juego/crucigrama',
        name:'ManagementCrucigrama',
        component: () => import('../views/crucigrama/ManagmentCrucigrama.vue'),
        meta: {
          auth: true
        }
      },

      ]
  },
  {
    path: '/auth',
    redirect: 'auth/login',
    component: Auth,
    children: [
      {
        path: '/auth/login',
        name:'login',
        component: () => import('../views/Login.vue')
      }


    ]
  }
];
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    firebase.auth().onAuthStateChanged(function(user) {
      if (!user) {
        next('/auth');
      } else {
        next();
      }
    });
  } else {
    next();
  }
});
export default router
